// extracted by mini-css-extract-plugin
module.exports = {"base":"styles_base__2JZTI","breadcrumb":"styles_breadcrumb__3n8OA"};